import React from "react";
import "./LegalPages.css";

const TermsOfUse = () => {
  return (
    <section className="legal-page">
      <h1>Terms of Use</h1>
      <p>
        Welcome to <b>Mailsnappy</b>. By accessing or using our website, services, or applications,
        you agree to comply with and be bound by these Terms of Use.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By using Mailsnappy, you confirm that you have read, understood, and agree to be bound by
        these Terms. If you do not agree, please refrain from using our services.
      </p>

      <h2>2. Service Description</h2>
      <p>
        Mailsnappy provides tools for email marketing, automation, analytics, and related digital
        communication services designed for businesses and organizations.
      </p>

      <h2>3. User Responsibilities</h2>
      <p>
        You agree to use Mailsnappy only for lawful purposes. You must not send spam, distribute
        harmful content, or violate any applicable laws or regulations.
      </p>

      <h2>4. Account Security</h2>
      <p>
        You are responsible for maintaining the confidentiality of your account information and
        password. Any unauthorized use of your account must be reported immediately.
      </p>

      <h2>5. Termination</h2>
      <p>
        We reserve the right to suspend or terminate your access if we detect misuse, illegal
        activity, or breach of our policies.
      </p>

      <h2>6. Changes to Terms</h2>
      <p>
        We may modify these Terms at any time. Continued use of Mailsnappy after changes implies
        acceptance of the updated Terms.
      </p>
    </section>
  );
};

export default TermsOfUse;
